// Résultats de recherche (tiroir et champs du header) :
// snippets/mds-predictive-search.liquid

document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', (event) => {
  event.currentTarget.querySelector('input[type="search"]')?.focus()
})

// Clavier mobile à l'ouverture de la recherche (bouton Recherche du menu bas,
// loupe du header) : iOS n'ouvre le clavier que si focus() est appelé PENDANT
// l'appui ; le focus de « shown.bs.offcanvas » (ci-dessus) arrive après
// l'animation (~300 ms), trop tard. On focalise donc le champ dès le click,
// juste après que Bootstrap a lancé l'ouverture (écouteur sur window = après
// son écouteur délégué sur document → le panneau a déjà .showing, donc
// visibility:visible, et le champ est focalisable).
window.addEventListener('click', (event) => {
  const trigger = event.target.closest?.('[aria-controls="offcanvas-search"]')
  const offcanvas = document.querySelector('#offcanvas-search')
  // .hiding : second appui pendant l'ouverture (le panneau se referme)
  if (!trigger || !offcanvas?.classList.contains('showing') || offcanvas.classList.contains('hiding')) return

  const input = offcanvas.querySelector('input[type="search"]')
  if (!input) return

  // En fin d'animation, le piège à focus de Bootstrap focalise le panneau
  // lui-même (tabindex="-1"), ce qui refermerait le clavier : le panneau est
  // rendu non focalisable jusqu'à « shown » (piège activé juste avant)
  const tabindex = offcanvas.getAttribute('tabindex')
  offcanvas.removeAttribute('tabindex')
  offcanvas.addEventListener('shown.bs.offcanvas', () => {
    if (tabindex !== null) offcanvas.setAttribute('tabindex', tabindex)
  }, { once: true })

  input.focus({ preventScroll: true })
})
